<template>
  <div>
    <el-dialog title="通知公告" :visible="notvisi" customClass="way notice tongzhi" :append-to-body="true"
      :befor-close="idevisi" @close='idevisi'>
      <div class="ibox-content">
        <div class="article">
          <h1>{{NoticeDel.ctitel}}</h1>
          <div class="text-muted">{{NoticeDel.ddate}}</div>
        </div>
        <div class="conters" v-html="NoticeDel.ccontent"></div><br>
        <!-- 暂无字段 -->
        <span v-if=" Noticefile.length!=0">附件：</span>
        <!-- <div class="fujian" v-if="NoticeDel.cfileurl!=''" @click="down()"><a style="cursor: pointer;">1、{{NoticeDel.cfilename}}</a></div> -->

        <div class="fujian" v-for="(file,i) in Noticefile" :key="i">
          <a style="cursor: pointer;" :href="file.cfileurl" target="_blank">{{i+1}}、{{file.ctitle}}</a>
        </div>
        <!-- <div class="fujian" v-if="NoticeDel.cfileurl==''" v-for="(file,i) in Noticefile" @click="downfile(file)">
          <a style="cursor: pointer;" :href="file.cfileurl" target="_blank">{{i+1}}、{{file.ctitle}}</a>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="idevisi()">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: {
      notvisi: { type: [Boolean], default: false },
      NoticeDel: { type: Object, default: {} },
    },
    data () {
      return {
        Noticefile: [],
      };
    },
    created () {
      console.log(this.NoticeDel);
      this.getfile();
    },

    methods: {
      getfile () {
        this.$axios({
          method: "post",
          url: "CommonModule/ImportExcel/Getbs_announcementFiles",
          data: { keyid: this.NoticeDel.id },
        }).then((res) => {
          console.log(res, "附件");
          if (res.data.Success) {
            this.Noticefile = res.data.Data;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 下载
      downfile (file) {
        if (file.cfileurl != "") {
          // 根据浏览地址下载文件;
          const a = document.createElement("a");
          let urlblob = file.cfileurl;

          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = ""; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        } else {
          this.$message.error("暂无文件");
        }
      },
      // 下载
      down () {
        if (this.NoticeDel.cfileurl != "") {
          // 根据浏览地址下载文件;
          const a = document.createElement("a");
          let urlblob = this.global.bxiosdow + this.NoticeDel.cfileurl;
          console.log(urlblob);
          window.open(urlblob);
          // var x = new XMLHttpRequest();
          // x.open("GET", urlblob, true);
          // x.responseType = "blob";
          // this.saveAs(
          //   new Blob([x], { type: "text/plain;charset=UTF-8" }),
          //   "合同模板"
          // );
          fetch(urlblob)
            .then((res) => res.blob())
            .then((blob) => {
              // 将链接地址字符内容转变成blob地址
              a.href = URL.createObjectURL(blob);
              console.log(a.href);
              a.download = ""; // 下载文件的名字
              document.body.appendChild(a);
              a.click();
            });
        } else {
          this.$message.error("暂无文件");
        }
      },
      idevisi () {
        this.$emit("notvisiif");
      },
    },
  };
</script>
<style scoped>
  .article h1 {
    font-size: 18px;
    line-height: 50px;
    font-weight: 700;
    color: #2f4050;
    text-align: center;
  }

  .text-muted {
    color: #888888;
    text-align: center;
  }

  .ibox-content {
    background-color: #ffffff;
    width: 96%;
    overflow-y: auto;
    color: black;
    padding: 0px 20px 20px 20px;
    max-height: 360px;
    min-height: 200px;
    margin-bottom: 20px;
    border-color: #e7eaec;
    border-image: none;
    border-style: solid solid none;
    border-width: 1px 0;
  }

  .fujian {
    text-align: left;
    line-height: 25px;
    color: #2440b3;
  }

  .conters {
    padding-top: 20px;
    min-height: 200px;
  }
</style>